/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import {
  TooltipComponent,
  TitleComponent,
  ToolboxComponent,
  LegendComponent,
  GridComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { BarChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import { Card, CardBody } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';

// Register the necessary chart components
echarts.use([
  TitleComponent,
  TooltipComponent,
  ToolboxComponent,
  LegendComponent,
  GridComponent,
  BarChart,
  CanvasRenderer
]);

const BarChartComponent = ({ data, type }) => {
  const [chartOption, setChartOption] = useState({});
  const colors = [
    '#5470C6',
    '#91CC75',
    '#EE6666',
    '#FAC858',
    '#00C0C7',
    '#FC8452',
    '#6E7074',
    '#546570',
    '#C4CCD3'
  ];

  useEffect(() => {
    if (data?.chartDatas?.length) {
      setChartOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '5%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: data.chartDatas.map(item => item.label),
          axisLabel: {
            rotate: 45,
            formatter: function (value) {
              return value.length > 10 ? `${value.slice(0, 10)}...` : value;
            }
          }
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: 'Value',
            type: type || 'bar',
            data: data.chartDatas.map((item, index) => ({
              value: parseFloat(item.value),
              itemStyle: {
                color: colors[index % colors.length] // Cycle through colors array
              }
            })),
            label: {
              // show: true,
              // position: 'top'
            }
          }
        ]
      });
    }
  }, [data]);

  return (
    <Card className="h-100">
      <FalconCardHeader
        title={data?.chartTitle}
        titleTag="h5"
        light={true}
        endEl={<></>}
      />
      <CardBody>
        <ReactEChartsCore
          echarts={echarts}
          option={chartOption}
          style={{ minHeight: '25.75rem', width: '100%' }}
        />
      </CardBody>
    </Card>
  );
};

BarChartComponent.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      drilldown_value: PropTypes.string,
      tooltip: PropTypes.string
    })
  ).isRequired
};

export default BarChartComponent;
